import { render, staticRenderFns } from "./ErrorAppVersionModal.vue?vue&type=template&id=ecf875ae&"
import script from "./ErrorAppVersionModal.vue?vue&type=script&lang=js&"
export * from "./ErrorAppVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAppVersionModal.vue?vue&type=style&index=0&id=ecf875ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports